import React, { Component } from 'react'
import Sequencer from '../Sequencer/Sequencer'
import './App.css'

class App extends Component {
  render() {
    return (
      <div className='app'>
        <Sequencer />
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App/App.js